<script>
    import vk from "$lib/images/socials/vk.svg?raw";
    const list = [
        {
            "label": "Группа ВКонтакте",
            "link": "https://vk.com/pro_baits",
            "icon": vk
        }
    ]
</script>

<div class="socialList">
    {#each list as {link, label, icon}}
        <a class="social__item" href={link} target="_blank" rel="noreferrer nofollow">
            <span class="social__label">
                {label}
            </span>
            {@html icon}
        </a>
    {/each}
</div>

<style lang="postcss">
    .social__label{
        display: none;
    }
    .social__item{
        display: flex;
        align-items: center;
        gap: 0.8rem;
        text-transform: none;
        font-size: 0.75rem;
        &:hover :global(svg){
            color: var(--color-bg-1);
        }
    }
    .socialList :global(svg){
        size: 1.75rem;
        color: var(--color-bg-0);
    }
    @media (min-width:992px){
        .social__label{
            display: inline;
        }
        .socialList :global(svg){
            size: 1rem;
            color: var(--color-bg-0);
        }
    }
</style>